import React, { useState, useEffect, useRef } from 'react';
import { Tag } from 'primereact/tag';


export default function TagAtivo(props){

    return <Tag severity="success" value="ATIVO" style={{cursor :'pointer'}}></Tag>
}